import { JSX, useEffect } from "react";

export const UtilsScrollTop = (): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <></>;
};
